// Import model
import { FilterContactAppointmentRequest } from '../models/FilterContactAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContactAppointmentCondition } from '../models/ContactAppointmentCondition';
import { ContactAppointmentFields } from '../models/ContactAppointmentFields';
import { ContactAppointmentIndexedFields } from '../models/ContactAppointmentIndexedFields';

// Import dependency serializers (for complex types)
import { ContactAppointmentConditionSerializer } from './ContactAppointmentConditionSerializer';
import { ContactAppointmentFieldsSerializer } from './ContactAppointmentFieldsSerializer';
import { ContactAppointmentIndexedFieldsSerializer } from './ContactAppointmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterContactAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterContactAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterContactAppointmentRequest instance
   */
  static deserialize(json: string): FilterContactAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterContactAppointmentRequest instance
   */
  static fromObject(obj: any): FilterContactAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterContactAppointmentRequest');
    }


    const instance: FilterContactAppointmentRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ContactAppointmentIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ContactAppointmentFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ContactAppointmentConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterContactAppointmentRequest instances
   */
  static deserializeArray(json: string): FilterContactAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterContactAppointmentRequest instance to a JSON string
   */
  static serialize(instance: FilterContactAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterContactAppointmentRequest instance to a plain object
   */
  static toObject(instance: FilterContactAppointmentRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ContactAppointmentConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterContactAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: FilterContactAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
